import React from 'react';
import {
	useTranslate,
	refreshView,
	CheckboxGroupInput,
	useNotify,
	useUpdate,
} from 'react-admin';
import IconRoles from '@material-ui/icons/VpnKey';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';
import BaseDialog from '../../components/dialog/BaseDialog';

const userRolesForSelection = ['ADMIN', 'MERCHANT', 'CONSUMER', 'ADMIN_RO'].map(key => {
	return { id: key, name: key };
});

const UpdateRoles = props => {
	const notify = useNotify();
	const translate = useTranslate();
	const dispatch = useDispatch();
	const [updateRoles] = useUpdate('userRoles');

	const { record, version } = props;

	const submit = (values, hideDialog) => {
		updateRoles(
			{
				payload: {
					id: record.id,
					data: values,
					method: null,
				},
			},
			{
				onSuccess: () => {
					notify('resources.users.notifications.roles');
					dispatch(refreshView());
					hideDialog();
				},
				onFailure: (error) => {
					notify(error.message, 'error');
				},
			},
		);
	};

	return (
		<BaseDialog
			icon={<IconRoles />}
			buttonLabel={translate('resources.users.labels.updateRoles')}
			dialogTitle={translate('resources.users.labels.updateRoles')}
			handleSubmit={submit}
		>
			{({ handleSubmit, hideDialog }) => (
				<Form
					initialValues={record}
					onSubmit={values => handleSubmit(values, hideDialog)}
					key={version}
					keepDirtyOnReinitialize
					render={({ handleSubmit }) =>
						<form onSubmit={handleSubmit}>
							<CheckboxGroupInput source="roles" choices={userRolesForSelection} />
						</form>
					}
				/>
			)}
		</BaseDialog>
	);
};

export default UpdateRoles;
